import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_GROUP_RESIT_REGISTRATION_CONFIRM_AND_PAY } from '../../constants/apiUrls';
import { CandidateModel } from './model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface GroupResitPaymentModel {
  resitCandidateList: CandidateModel[];
  paymentMode: string;
}

export interface ResitTransactionResponse {
  internalTransactionRef: string;
  paymentSuccess: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: ResitTransactionResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostConfirmAndPay = ({ onSuccess, onError }: Input = {}) => {
  const postConfirmAndPay = async (payload: {
    uuid: string;
    groupResitPayment: GroupResitPaymentModel;
  }) => {
    const res = await axiosClient.post<ResitTransactionResponse>(
      POST_GROUP_RESIT_REGISTRATION_CONFIRM_AND_PAY(payload.uuid),
      payload.groupResitPayment
    );
    return res.data;
  };

  return useCustomMutation(postConfirmAndPay, {
    onSuccess,
    onError,
  });
};
